import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function AdminEmail() {
  const [config, setConfig] = useState([])
  const [edits, setEdits] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('email_config').select('*').order('chiave')
    setConfig(data || [])
    setLoading(false)
  }

  async function save(chiave) {
    const v = edits[chiave]; if (v === undefined) return
    await supabase.from('email_config').update({ valore: v }).eq('chiave', chiave)
    setEdits(s => { const x={...s}; delete x[chiave]; return x })
    load()
  }

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header">
        <h1>Configurazione email</h1>
        <p>Indirizzi destinatari e template oggetto. Le credenziali SMTP sono in variabili d'ambiente Vercel (non qui per sicurezza).</p>
      </div>

      <div className="info-box mt-1" style={{ marginBottom: '1rem' }}>
        <strong>Flusso email:</strong><br/>
        1. Quando il dealer invia una pratica → mail a <code>email_admin</code> con dati e allegati.<br/>
        2. Quando l'admin approva o rifiuta dalla lista pratiche → mail al dealer con esito (template <code>email_oggetto_approvazione</code> o <code>email_oggetto_rifiuto</code>) e cancellazione del record.
      </div>

      <div className="card">
        {config.map(c => {
          const v = edits[c.chiave] !== undefined ? edits[c.chiave] : c.valore
          const dirty = edits[c.chiave] !== undefined
          return (
            <div key={c.chiave} className="form-group">
              <label><strong>{c.chiave}</strong></label>
              <input value={v} onChange={e => setEdits(s => ({ ...s, [c.chiave]: e.target.value }))}
                     style={{ background: dirty?'#FFF7E5':'transparent' }} />
              <div className="hint">{c.descrizione}</div>
              {dirty && <button className="btn btn-sm btn-primary mt-1" onClick={() => save(c.chiave)}>Salva</button>}
            </div>
          )
        })}
      </div>

      <div className="card mt-2">
        <h2 className="card-title">Variabili SMTP (lato Vercel)</h2>
        <p className="text-small text-muted">
          Le seguenti variabili vanno impostate nel pannello Vercel &gt; Settings &gt; Environment Variables.
          Non sono modificabili da questa pagina per sicurezza.
        </p>
        <ul className="text-small" style={{ marginLeft: '1.5rem', marginTop: 8 }}>
          <li><code>SMTP_HOST</code> - server SMTP (es. smtp.aruba.it)</li>
          <li><code>SMTP_PORT</code> - porta (587 STARTTLS o 465 SSL)</li>
          <li><code>SMTP_USER</code> - utenza</li>
          <li><code>SMTP_PASS</code> - password</li>
          <li><code>SMTP_FROM</code> - mittente (es. "Amica CVT &lt;noreply@amica.it&gt;")</li>
          <li><code>SUPABASE_SERVICE_ROLE_KEY</code> - per la function server-side (non esporre al client!)</li>
        </ul>
      </div>
    </div>
  )
}
